module.exports = __webpack_public_path__ + "img/lake-cabin-15.b360969c.jpg";